import React, { useState } from "react";
import axios from "axios";
// const host = 'https://face-finder.chickenkiller.com';
// const host = 'http://localhost:8080'
const ZipUpload = () => {
  const [zipFile, setZipFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setZipFile(file);
  };

  const handleUpload = async () => {
    try {
      const formData = new FormData();
      formData.append("zipFile", zipFile);

      const response = await axios.post(
        "https://backend.annualcreditconference.in/upload-zip",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(response.data.message);
    } catch (error) {
      console.error(error);
      setMessage("Error uploading zip file");
    }
  };

  return (
    <div>
      <h2>Upload Zip File</h2>
      <input type="file" accept=".zip" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload Zip File</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ZipUpload;
